import { th } from 'style/theme';
import styled, { css } from 'styled-components';

export const Label = styled.div`
  position: absolute;
  font-size: 12px;
  line-height: 16px;
  color: ${th('colors.osloGray')};
  left: 12px;
  top: 8px;
`;

export const ControlInner = styled.div`
  > :first-child {
    overflow: initial;
  }
`;

export const StyledSingleValue = styled.div.attrs({ className: 'single-value' })`
  top: 0;
  left: 1px;
  color: ${th('colors.pickledBluewood')};
  border-radius: 16px;
  font-size: 16px;
  line-height: 22px;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: absolute;

  ${({ hasLabel }) =>
    !hasLabel &&
    css`
      top: 2px;
      font-weight: 500;
    `};

  > img {
    position: relative;
    bottom: 1.5px;
    margin-right: 6px;
  }
`;

export const StyledOption = styled.div`
  background-color: ${({ variant }) => th(`colors.inputs.${variant}.base`)};
  display: flex;
  flex-direction: row;
  padding: 12px;
  border-radius: 12px;
  gap: 8px;
  align-items: center;
  font-size: 16px;
  font-weight: ${({ selected }) => (selected ? 500 : 400)};
  cursor: pointer;
  color: ${th('colors.pickledBluewood')};
  transition: background-color 200ms;

  :hover {
    background-color: ${({ variant }) => th(`colors.inputs.${variant}.optionHover`)};
  }
`;
